import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showFreeSpinTransition: false,
  showFreeSpinIntro: false,
  showReelDecoration: false,
  showFreeSpinOutro: false,
  showFreeSpinRetrigger: false,
  freeSpinOutroTriggered: false, // Prevent duplicate outro triggers
  freeSpinCounterFinished: false,
  freeSpinLinesRotationFinished: false,
  freeSpinWinCounterFinished: false,
  coverSymbolsInitial: false,
  revealSymbolsFinal: false,
  isFreeSpinDimActive: false,
};

const freeSpinAnimationsSlice = createSlice({
  name: "freeSpinAnimations",
  initialState,
  reducers: {
    setCoverSymbolsInitial: (state, action) => {
      state.coverSymbolsInitial = action.payload;
    },
    setRevealSymbolsFinal: (state, action) => {
      state.revealSymbolsFinal = action.payload;
    },
    setShowFreeSpinTransition: (state, action) => {
      state.showFreeSpinTransition = action.payload;
    },
    setShowFreeSpinIntro: (state, action) => {
      state.showFreeSpinIntro = action.payload;
    },
    setShowReelDecoration: (state, action) => {
      state.showReelDecoration = action.payload;
    },
    setShowFreeSpinOutro: (state, action) => {
      state.showFreeSpinOutro = action.payload;
    },
    setShowFreeSpinRetrigger: (state, action) => {
      state.showFreeSpinRetrigger = action.payload;
    },
    setFreeSpinCounterFinished: (state, action) => {
      state.freeSpinCounterFinished = action.payload;
    },
    setFreeSpinLinesRotationFinished: (state, action) => {
      state.freeSpinLinesRotationFinished = action.payload;
    },
    setFreeSpinWinCounterFinished: (state, action) => {
      state.freeSpinWinCounterFinished = action.payload;
    },
    setIsFreeSpinDimActive: (state, action) => {
      state.isFreeSpinDimActive = action.payload;
    },
    setFreeSpinOutroTriggered: (state, action) => {
      state.freeSpinOutroTriggered = action.payload;
    },
    resetFreeSpinAnimations: () => {
      return initialState;
    },
  },
});

// ==============================
// 🔹 Memoized Selectors
// ==============================

// ✅ Simple selector, no memoization needed
export const selectShowFreeSpinTransition = (state) =>
  state.freeSpinAnimations.showFreeSpinTransition;

export const selectShowFreeSpinIntro = (state) =>
  state.freeSpinAnimations.showFreeSpinIntro;

export const selectShowFreeSpinRetrigger = (state) =>
  state.freeSpinAnimations.showFreeSpinRetrigger;

export const selectShowFreeSpinOutro = (state) =>
  state.freeSpinAnimations.showFreeSpinOutro;

export const selectIsFreeSpinDimActive = (state) =>
  state.freeSpinAnimations.isFreeSpinDimActive;

export const selectShowReelDecoration = (state) =>
  state.freeSpinAnimations.showReelDecoration;

export const {
  setShowFreeSpinTransition,
  setShowFreeSpinIntro,
  setShowReelDecoration,
  setShowFreeSpinOutro,
  setShowFreeSpinRetrigger,
  setFreeSpinCounterFinished,
  setFreeSpinLinesRotationFinished,
  setFreeSpinWinCounterFinished,
  setFreeSpinOutroTriggered,
  resetFreeSpinAnimations,
  setCoverSymbolsInitial,
  setRevealSymbolsFinal,
  setIsFreeSpinDimActive,
} = freeSpinAnimationsSlice.actions;

export default freeSpinAnimationsSlice.reducer;
